export enum ReviewStatus {
  Empty = 'empty',
  Draft = 'draft',
  Published = 'published',
}
